module.exports = __webpack_public_path__ + "static/media/trumpet.365f0666.svg";